module.exports = __webpack_public_path__ + "static/img/scanner.52542c36.png";